import { machineTypeSchema } from "@packsize/schemas/machines";

export const EM_MACHINES_QUERY_KEY = ["machines", { machineType: machineTypeSchema.enum.Em }] as const;
